/**
 * 계정 관리 페이지 (리팩터링 버전)
 *
 * - 로직: `useAccountList`
 * - UI: PC/모바일 반응형(Tailwind 유틸 + 기존 공통 스타일 공존)
 * - 구성: 검색 / 목록 / 상세(등록·수정)
 */
import AccountPage from "./account/AccountPage";

const Account = () => <AccountPage />;

export { Account };
